"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmailRecipient = void 0;
const getEmailRecipient = (data, template) => {
    switch (template.default_recipient) {
        case "CLIENT":
            return data.client.email;
        case "SUPPORT":
            return "support@golfsavers.com";
        default:
            return "golfsaverssuppliertest@gmail.com";
    }
};
exports.getEmailRecipient = getEmailRecipient;
